/**
 *
 * PasswordRequirementsModal
 *
 */

import React from 'react';
import {
  Wrapper,
  IconWrapper,
  Text,
  Ul,
  Li,
  Link,
  Center
} from './styledComponents'

import PasswordSVG from 'components/Icon/PasswordSVG';
import Modal from 'components/Modal';
import H1 from 'components/H1';

const PasswordRequirementsModal = ({ close }) => (
  <Modal close={close} title='Password Requirements'>
    <Wrapper>
      <IconWrapper>
        <PasswordSVG />
      </IconWrapper>
      <H1>Security is key. </H1>
      <Text>
        <p>Your Movebooth password needs:</p>
        <Ul className='password-requirements-modal__ul'>
          <Li>{"at least 8 characters"}</Li>
          <Li>{"one upper case letter"}</Li>
          <Li>{"one lower case letter"}</Li>
          <Li>{"one number"}</Li>
          <Li>{"one special character, like !@#$%^&*;.)"}</Li>
        </Ul>
      </Text>

      <Center>
        <Link to='/forgot-password' onClick={() => close()}>
          Forgot your password?
        </Link>
      </Center>

    </Wrapper>
  </Modal>
);

export default PasswordRequirementsModal;



// WEBPACK FOOTER //
// ./src/components/PasswordRequirementsModal/index.js